export const SET_PERMISSION = "SET_PERMISSION";
export const DELETE_PERMISSION = "DELETE_PERMISSION";
export const RESET_PERMISSION = "RESET_PERMISSION";
